// Activity Dictionary Configuration
// Maps activity types to their display names and metadata

const activityDictionary = {
    PRODUCTION: {
        id: 'PRODUCTION',
        displayName: 'Production',
        description: 'Energy production activities',
        color: '#4CAF50',
        icon: 'factory',
        active: true
    },
    REFINERY_INTAKE: {
        id: 'REFINERY INTAKE',
        displayName: 'Refinery Intake',
        description: 'Crude oil and raw materials entering refineries',
        color: '#2196F3',
        icon: 'input',
        active: true
    },
    REFINERY_OUTPUT: {
        id: 'REFINERY OUTPUT',
        displayName: 'Refinery Output',
        description: 'Refined petroleum products output',
        color: '#FF9800',
        icon: 'output',
        active: true
    },
    CONSUMPTION: {
        id: 'CONSUMPTION',
        displayName: 'Consumption',
        description: 'Energy consumption and usage',
        color: '#F44336',
        icon: 'trending_down',
        active: true
    },
    INVENTORY: {
        id: 'INVENTORY',
        displayName: 'Inventory',
        description: 'Storage and inventory levels (stocks)',
        color: '#9C27B0',
        icon: 'inventory',
        active: true
    },
    DIRECT_BURN: {
        id: 'DIRECT BURN',
        displayName: 'Direct Burn',
        description: 'Direct combustion activities',
        color: '#FF5722',
        icon: 'local_fire_department',
        active: true
    },
    EXPORTS: {
        id: 'EXPORTS',
        displayName: 'Exports',
        description: 'Energy exports',
        color: '#00BCD4',
        icon: 'flight_takeoff',
        active: false
    },
    GOVERNMENT_STRATEGIC_STOCKING: {
        id: 'GOVERNMENT STRATEGIC STOCKING',
        displayName: 'Government Strategic Stocking',
        description: 'Strategic petroleum reserves',
        color: '#607D8B',
        icon: 'security',
        active: false
    },
    IMPORTS: {
        id: 'IMPORTS',
        displayName: 'Imports',
        description: 'Energy imports',
        color: '#3F51B5',
        icon: 'flight_land',
        active: false
    },
    PRICE_ESTIMATE: {
        id: 'PRICE ESTIMATE',
        displayName: 'Price Estimate',
        description: 'Price estimates and forecasts',
        color: '#8BC34A',
        icon: 'attach_money',
        active: false
    }
};

// Helper functions
export const getActivityById = (id) => {
    return activityDictionary[id] || null;
};

export const getAllActivities = () => {
    return Object.values(activityDictionary).filter(activity => activity.active);
};

export default activityDictionary;